import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PrivateProfile } from 'src/app/models/private-profile';
import { FirebaseAuthService } from 'src/app/_services/firebase-auth.service';
import { UserService } from 'src/app/_services/user.service';
import { CustomValidators } from '../../../models/custom-validators';
import { AlertService } from '../../../_services/alert.service';
import { DocType } from '../../../models/doc-type';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  public frmSignup: FormGroup;
  isRefered: boolean;
  sponsorId: string;
  sponsorDisplayName: string;
  sponsorVerified = false;
  documentUsed = false;
  isValidDocument = false;
  passwordType = 'password';
  passwordShown = false;
  validSponsor =  true;
  termsAcepted = false;
  emailReferente: any;
  documentTypes: DocType[];
  selectedDocumentType: DocType;

  constructor(private fb: FormBuilder, private firebaseAuthService: FirebaseAuthService, private userService: UserService,
              private fireStore: AngularFirestore, private alertService: AlertService) { }

  ngOnInit(): void {
    this.frmSignup = this.createSignupForm();
    this.loadDocumentTypes();
  }

  createSignupForm(): FormGroup {
    return this.fb.group({
      fullName: ['', Validators.required],
      userName: ['', Validators.required],
      email: [null, Validators.compose([
        Validators.email,
        Validators.required])
      ],
      documentType: ['CC', Validators.required],
      document: [ null , [Validators.required, Validators.minLength(6)]],
      password: [
        null,
        Validators.compose([
          Validators.required,
          // check whether the entered password has a number
          CustomValidators.patternValidator(/\d/, {
            hasNumber: true
          }),
          // check whether the entered password has upper case letter
          CustomValidators.patternValidator(/[A-Z]/, {
            hasCapitalCase: true
          }),
          // check whether the entered password has a lower case letter
          CustomValidators.patternValidator(/[a-z]/, {
            hasSmallCase: true
          }),
          // check whether the entered password has a special character
          CustomValidators.patternValidator(
            /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
            {
              hasSpecialCharacters: true
            }
          ),
          Validators.minLength(6)
        ])
      ],
      confirmPassword: [null, Validators.compose([Validators.required])],
      isRefered: [ ],
      emailSponsor: [],
      termsAndConditions: [],
      emailOffers: [false]
    },
      {
        // check whether our password and confirm password match
        validator: CustomValidators.passwordMatchValidator
      });
  }

  async createUser(): Promise<any> {

    if (this.frmSignup.valid &&
        (this.sponsorVerified && this.isRefered || !this.isRefered) &&
        !this.documentUsed && this.isValidDocument ) {
     this.firebaseAuthService.register(this.frmSignup.value.email, this.frmSignup.value.password)
      .then(result => {

        return this.fireStore.collection('users').doc(result.user.uid).set({
          displayName: this.frmSignup.value.userName,
          termsAndConditions: true,
          email: this.frmSignup.value.email,
          rol: 'usuario',

        }).then( () => {

          const privateProfile = new PrivateProfile();

          privateProfile.sponsorId = (this.isRefered ? this.sponsorId : 'TuGessiAdminUser');
          privateProfile.sponsorDisplayName = (this.isRefered ? '' : 'TuGessi.com');
          privateProfile.sponsorEmail = this.isRefered ? '' : 'desarrollo.tugessi@gmail.com';
          privateProfile.fullName = this.frmSignup.value.fullName;
          privateProfile.termsAndConditions = true;
          privateProfile.emailOffers = this.frmSignup.value.emailOffers;
          privateProfile.email = this.frmSignup.value.email;
          privateProfile.document = this.frmSignup.value.document.toString();
          privateProfile.documentType = this.frmSignup.value.documentType;
          privateProfile.displayName = this.frmSignup.value.userName;
          privateProfile.rol = 'usuario';

          this.fireStore.collection('users').doc(result.user.uid)
              .collection('privateProfile').add({
                ...privateProfile
          });
        }).catch(error => {
          console.log(error);
        });
      })

      .then( () => {

        this.firebaseAuthService.sendEmailVerification();

        this.alertService.openAlertDialog('Enviamos un correo para confirmar tu cuenta. '
                          + 'Por favor revisa tu correo para activar la cuenta', false, false);

        this.alertService.alertDialgoRef.afterClosed().subscribe(result => {
          this.firebaseAuthService.logout();

        });
      })
      .catch( error => {

        switch (error.code) {
          case 'auth/email-already-in-use':
            this.alertService.openAlertDialog('El email ya se encuentra en uso, por favor verifícalo', false, false);
            break;
          default:
            this.alertService.openAlertDialog('Ocurrió un error desconocido', true, false);
            break;
        }
      });
    } else {
      this.alertService.openAlertDialog('Debes completar los campos obligatorios', false, false);
    }
  }

  togglePassword(): void {
    if (this.passwordShown) {
      this.passwordShown = false;
      this.passwordType = 'password';
    } else {
      this.passwordShown = true;
      this.passwordType = 'text';
    }
  }

  OnChekboxChange(e): void {
    this.isRefered = this.frmSignup.get('isRefered').value;
    if (this.isRefered ) {
      this.validSponsor = false;
    }
  }

   async verifySponsorExist(email: string): Promise<void> {
    this.firebaseAuthService.verifySponsor(email)
      .subscribe(answ => {

        this.sponsorId = answ.toString();
        this.sponsorVerified = true;
        this.alertService.openAlertDialog('¡Patrocinador confirmado!', false, false);
      }, error => {
        this.sponsorVerified = false;
        if (error.error.message === 'Sponsor not found') {
          this.alertService.openAlertDialog('Por favor verifica el correo de la persona que te refirió', true, false);
        } else if (error.error.message === 'Not email confirmed') {
          this.alertService.openAlertDialog('El usuario no ha confirmado su cuenta, ¡por favor avísale!', true, false);
        } else {
          this.alertService.openAlertDialog('Error desconocido al verificar el correo del referido', true, false);
        }
      });
  }

  async verifyDocumentExists(): Promise<void> {

    this.firebaseAuthService.veryfyDocumentAndTypeAvailable(this.selectedDocumentType.name, this.frmSignup.value.document)
      .subscribe(anws =>
      {

          if (anws.valid) {
            this.documentUsed = false;
            this.isValidDocument = true;
          } else {
            this.documentUsed = true;
            this.isValidDocument = false;
          }
        });
  }

  disableSubmmit(): void{
    console.log('disable');

    this.isValidDocument = false;
  }

  OnChekboxTemsCondChange(e): void{
    this.termsAcepted = this.frmSignup.get('termsAndConditions').value;
  }

  loadDocumentTypes() {
    this.userService.getDocumentTypes().subscribe(documents => {
      this.documentTypes = documents;

      this.selectedDocumentType = this.documentTypes.find(doc => doc.name == 'CC');
      console.log(this.documentTypes);
      console.log('Documento seleccionado:', this.documentTypes);

    });
  }

  documentTypeSelection(docSelected) {

    this.selectedDocumentType = this.documentTypes.find(doc => doc.name == docSelected);

  }



}
